import { connect } from "socket.io-client";
import { getSocketEndPoint } from "../util/network/apiUrl";

export const initiateSocketConnection = (location, accessToken) => {
  try {
    const socket = connect(getSocketEndPoint(), {
      path: "/socket.io",
      allowUpgrades: true,
      transports: ["websocket"],
      forceNew: true,
      query: { location },
      auth: { token: accessToken },
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2500,
      reconnectionDelayMax: 10000,

      timeout: 60000,
      pingInterval: 60000,
      pingTimeout: 60000
    });


    return socket;
  } catch (err) {
    console.error("Error initiating socket connection:", err);
    throw err;
  }
};
